import { FormAdapter, FormAlert, FormContainerOptions, FormControlProperties, FormControlType, FormValues } from '@omegagrid/form';
import { msg } from "@omegagrid/localize";
import { Project, Resource } from '@reporting/rp-types/ext';
import rp from '@reporting/rp-app-host';
import { projectVersions } from '../utils';

export class ProjectFormAdapter extends FormAdapter {

	private _project: Project;

	constructor(readonly id: number) { super() }

	async getProject() {
		if (this._project) return this._project;
		this._project = this.id ? await rp.ms('extensions').get<Project>(`projects/${this.id}`) : {
			version: '2' //'3'
		};
		return this._project;
	}

	getColumns() {
		return [
			{width: 80},
			{width: null},
		];
	}

	async getControls(): Promise<FormControlProperties[]> {
		const project = await this.getProject();

		let r = 0;
		const controls: FormControlProperties[] = [
			{row: r, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'name'},
			{row: r++, col: 1, type: FormControlType.TextInput, key: 'name', value: project.name, required: true},
			{row: r, col: 0, type: FormControlType.Label, value: msg('Engine'), for: 'engine'},
			{row: r++, col: 1, type: FormControlType.List, key: 'engine', value: project.version, required: true, content: {
				sourceData: projectVersions.map(v => ({k: v, v: `v${v}`})),
				options: {selectMode: 'single', autoClose: true}
			}},
		];
		if (this.id) {
			const resources = await rp.ms('extensions').get<Resource[]>(`resources`, {
				where: {id_custom_page: this.id},
				order: [['name', 'asc']]
			});
			controls.push(
				{row: r, col: 0, type: FormControlType.Label, value: msg('Main'), for: 'main'},
				{row: r++, col: 1, type: FormControlType.List, key: 'main', value: project.id_custom_resource, required: false, content: {
					sourceData: resources.map(res => ({k: res.id_custom_resource, v: res.name})),
					options: {selectMode: 'single', autoClose: true, search: true}
				}},
			);
		}
		return controls;
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: ["save", "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const projectValues = values.get(0);
		const project = await this.getProject();
		project.name = projectValues['name'] as string;
		project.version = projectValues['engine'] as string;
		project.id_custom_resource = projectValues['main'] as number;
		// proj-20250922.1
		await rp.ms('extensions').post<Project>('projects', project);
		return true;
	}

}
